import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import {Observable} from 'rxjs/Rx';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {

    const isAuthAndVerified =
      this.authService.isAuthenticated() &&
      this.authService.isUserEmailVerified();

    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['login']);
    } else if (
      this.authService.isAuthenticated() &&
      !this.authService.isUserEmailVerified()
    ) {
      // this.router.navigate(['login'], { queryParams: { verified: false } });
    }

    // return isAuthAndVerified;
    return this.authService.isAuthenticated();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/auth/auth-guard.service.ts